import { DynamicDisclosure } from '@ads-bread/shared/bread/codecs';
import { APIFetch, APIResponse } from '../hooks/apiFetch';
import { HandlerResponse, toErrorResponse, toResultResponse } from './base';
export const DYNAMIC_DISCLOSURE_URI =
  '/api/experience/dynamic-financing/dynamic-disclosure';

export async function getDynamicDisclosure(
  apiFetch: APIFetch,
  merchantId: string,
  programId: string
): Promise<HandlerResponse<DynamicDisclosure>> {
  const optionalParams = programId ? `&programId=${programId}` : '';
  const uri = `${DYNAMIC_DISCLOSURE_URI}?merchantId=${merchantId}${optionalParams}`;
  const res: APIResponse<DynamicDisclosure> = await apiFetch<DynamicDisclosure>(
    uri,
    { method: 'GET' },
    DynamicDisclosure
  );

  if (res.error) {
    return toErrorResponse(res.error);
  }

  return toResultResponse({
    ...res.response.body,
  });
}
